// @ts-nocheck
import { useState } from "react";
import Rating from "react-rating";
import { Card, CardBody, Col } from "reactstrap";
import { SquareRatingBar } from "../../../Constants/Constants";
import { SquareRatingData } from "../../../Data/BonusUi/Rating";
import { dynamicNumber } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SquareRating = () => {
  const [rating, setRating] = useState(1);

  return (
    <Col xxl="4" md="6">
      <Card>
        <CommonCardHeader title={SquareRatingBar} span={SquareRatingData} />
        <CardBody>
          <div className="rating">
            <Rating
              initialRating={rating}
              emptySymbol={dynamicNumber(5).map((n: number) => (<span className="square-number" key={n}>{n}</span>))}
              fullSymbol={dynamicNumber(5).map((n: number) => (<span className="square-number active" key={n}>{n}</span>))}
              onChange={(rate) => setRating(rate)}
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default SquareRating;
